import { Beneficiary } from '../../pages/dashboard/payments/interfaces/Beneficiary';
import { useGetQuery } from '../useGetQuery';
import { useQueryClient } from 'react-query';
import { FilterParams } from '../../interfaces/Filter';

const defaultParams: FilterParams = {
    page: 1,
    size: 20
};

export const useBeneficiaries = (initialParams?: FilterParams) => {
    const queryClient = useQueryClient();
    const params = initialParams || defaultParams;

    const {
        isLoading,
        entries: beneficiariesData,
        isFetching: isBeneficiariesFetching,
        paging
    } = useGetQuery<Beneficiary[]>({
        url: `/corporate/beneficiary`,
        cacheKey: `beneficiaries-${params?.page}`,
        params: { ...params }
    });

    const invalidateBeneficiaryCache = () => {
        queryClient.invalidateQueries('beneficiaries');
    };

    return {
        beneficiaries: beneficiariesData || [],
        isLoading,
        invalidateBeneficiaryCache,
        isBeneficiariesFetching,
        beneficiaryPaging: paging
    };
};

export default useBeneficiaries;
